import { Button, Popover, Typography } from '@mui/material';
import { useEffect, useState } from 'react';

import { TimePicker } from '@/components/date/timePicker';
import { createDayJsTime } from '@/utils/dateTime';
import type { Dayjs } from '@/utils/dayjs';

export const TimeSelectorPopover = ({
  hours,
  minutes,
  seconds,
  onChange,
  showSeconds = false,
  showUTC = false,
  minTime,
  maxTime,
}: {
  hours: number;
  minutes: number;
  seconds?: number;
  onChange: (hours: number, minutes: number, seconds?: number) => void;
  showSeconds?: boolean;
  showUTC?: boolean;
  minTime?: Dayjs;
  maxTime?: Dayjs;
}) => {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
  const [popoverOpen, setPopoverOpen] = useState(false);
  const [value, setValue] = useState(createDayJsTime(hours, minutes, seconds));

  useEffect(() => {
    setValue(createDayJsTime(hours, minutes, seconds));
  }, [hours, minutes, seconds]);

  return (
    <>
      <Button
        sx={{
          padding: '5px 12px',
        }}
        ref={setAnchorEl}
        onClick={() => setPopoverOpen(true)}
        data-testid='create-backup-policy-time-select'
        disableFocusRipple
      >
        <Typography fontWeight={600}>
          {`${value.format(showSeconds ? 'HH:mm:ss' : 'HH:mm')}${showUTC ? ` UTC` : ''}`}
        </Typography>

        <i className='material-symbols-arrow-drop-down-rounded text-[22px] ml-[4px]' />
      </Button>
      <Popover
        disablePortal
        open={popoverOpen}
        anchorEl={anchorEl}
        onClose={() => {
          setPopoverOpen(false);
          onChange(value.hour(), value.minute(), value.second());
        }}
      >
        <TimePicker
          value={value}
          setValue={setValue}
          title='Backup start time'
          showSeconds={showSeconds}
          minTime={minTime}
          maxTime={maxTime}
        />
      </Popover>
    </>
  );
};
